import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private currentLanguage: string = 'es';

  constructor() { }

  setLanguage(language: string): void {
    this.currentLanguage = language;
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('language', language);
    }
  }

  getLanguage(): string {
    if (typeof localStorage !== 'undefined') {
      const storedLanguage = localStorage.getItem('language');
      if (storedLanguage) {
        return storedLanguage;
      }
    }
    return this.currentLanguage;
  }

  getWebisteTexts(): any {
    const language = this.getLanguage();

    const texts = {
      es: {
        navbar:{
          home: 'Inicio',
          about_us:'Quiénes somos',
          llantas:  {
            title: 'Productos',
            section: 'Tipo de vehículo',
            //subtitle: 'Vehículo eléctrico',
            subtitle: 'Listado de llantas',
            charger_title:'Cargadores'
          },
          information:{
            title: 'Información',
            tecnologia: 'Tecnología',
            premios: 'Premios al diseño',
            informacion: 'Información sobre llantas',
            tuv_sud: 'TÜV SÜD Alemania',
          },
          comprar_btn: ['Comprar', 'Llantas'],
        },
        home:{
          title: ['¡Potencia tu vehículo eléctrico con la calidad y el respaldo de los expertos!','Explora nuestra gama de productos hoy mismo y lleva tu experiencia de manejo al siguiente nivel con PRINX.','Una marca que ','DEJA HUELLA'],
          partners:{
            title:'Trabajamos con los mejores',
          },
          tires:{
            xlab:{
              title:'XLAB Confort EV',
              subtitle:'Silencioso y cómodo, incluso en mojado.',
              button_text: 'Más',
            },
            xnex:{
              title:'XNEX Sport EV',
              subtitle:'La emocionante opción para los vehículos eléctricos.',
              button_text: 'Más',
            },
          },
          social:{
            title:['¿Quieres más información sobre','nuestros productos'],
            subtitle: 'Síguenos en nuestras redes sociales para estar al tanto de todas las novedades y lanzamientos.',
          },
          distributor_banner: 'Distribuidor Exclusivo Para Costa Rica - MundoEV',
          future:{
            title: 'Futuro Sostenible',
            subtitle: 'Impulsando la movilidad eléctrica y la innovación para un mundo más limpio y sostenible. Únete a la revolución verde y sé parte del cambio.',
            more_info_btn: 'Más información',
          },
          awards:{
            title:['Ganador',' de varios premios internacionales de diseño'],
            events:[
              {
                title:`PREMIO A'DESIGN Y CONCURSO`,
                country:'Italia'
              },
              {
                title:'PREMIOS DE DISEÑO MUSE',
                country:'EE.UU'
              },
              
              {
                title:'PARIS DESIGN AWARDS 2022',
                country:'Francia'
              }
            ]
          },
          details:{
            subtitle:'A LA VANGUARDIA DE LA INNOVACIÓN',
            title:'PRINX ha establecido un círculo virtuoso de innovación para ofrecer llantas de alto rendimiento',
            details:[
              {
                title:'TECNOLOGÍA',
                description: [
                  'Nuestras innovaciones ofrecen algo más que prestaciones: garantizan viajes más seguros, mayor confort y un futuro más ecológico.',
                  'Al integrar tecnología avanzada, medidas de seguridad y materiales ecológicos, no nos limitamos a competir.',
                  'Estamos estableciendo un NUEVO ESTÁNDAR PARA LA INDUSTRIA.'
                ],
                more_info_btn:'ver más'
              },
              {
                title:'Rendimiento',
                description: [
                  'La tecnología está en el centro de nuestra visión, impulsando el desarrollo, la competitividad y el éxito duradero. Estamos comprometidos con la superación de los límites de los avances en la industria llantera, con materiales y tecnologías logrando llantas más seguras, duraderas y ecológicas. Descubre el futuro de la movilidad eléctrica.'
                ],
                more_info_btn:'ver más'
              },
              {
                title:'Certificación TÜV SÜD',
                description: [
                  'Nos comprometemos con la sostenibilidad utilizando materiales ecológicos y procesos de fabricación responsables, reduciendo el impacto ambiental en cada etapa del ciclo de vida de la llanta. Gracias a la integración de tecnologías inteligentes, como sensores para el monitoreo en tiempo real, nuestras llantas ofrecen un nivel superior de seguridad y rendimiento adaptativo.',
                  'Con PRINX, la innovación es el motor que nos impulsa a anticipar las necesidades del futuro, desarrollando productos que no solo cumplen, sino que superan las expectativas de los conductores más exigentes.'
                ],
                more_info_btn:'ver más'
              }
            ]
          }
        },        
        footer:{
          newsletter:{
            title:'Sube a bordo',
            placeholder:'Ingresa tu correo electrónico',
            suscribe_btn:'Suscribirse',
            success_message: 'Se ha suscrito correctamente.',
            error_message:'No se logró completar la solicitud, por favor intentelo de nuevo.'
          },
          titles:{
            tire_product:'LLANTA POR PRODUCTO',
            tire_vehicule:'LLANTA POR VEHICULO',
            who_we_are:'Quiénes somos',
            about:'Acerca de',
            policy_cookies:'Politica de cookies',
            policy_privacy:'Politica de privacidad',
            terms_conditions:'Términos y condiciones',
            distributor_title:'DISTRIBUIDORES',
            distributor_text:'Conviertase en distribuidor',
            distribuidores_autorizados: 'Somos distribuidores autorizados'
          },
          copyright: "Mundo EV - Todos los derechos reservados.",
          developer: "Desarrollado e implementado por",
        },
        electric_vehicule:{
          title:'¿Por Qué Elegir Mundo EV?',
          description:'En Mundo EV, somos los expertos en soluciones para la Movilidad Eléctrica. Cada producto que ofrecemos, comenzando por nuestras llantas PRINX, está diseñado específicamente para tu vehículo eléctrico, garantizando un rendimiento superior, mayor confort y la máxima seguridad. ',
          subtitle:'Nuestros productos no solo cumplen, sino que sobrepasan los exigentes estándares y certificaciones requeridos en mercados como Europa y Estados Unidos.',

          xnex:{
            title:'XNEX SPORT EV',
            description:'La emocionante opción para vehículos eléctricos.'
          },
          xlab:{
            title:'XLAB COMFORT EV',
            description:'Silencioso y cómodo, sobre mojado también.'
          },
        },

        technology:{
          title:'Tecnologías revolucionarias PRINX',
          subtitle:['En PRINX, la tecnología está en el centro de nuestra visión, impulsando el desarrollo, la competitividad y el éxito duradero.','Nuestro vanguardista Centro Tecnológico, dotado de expertos, está comprometido con la superación de los límites de los avances en la industria de la llanta. Explore nuevos productos, materiales y tecnologías para que sus llantas sean más seguras, duraderas y ecológicas. Descubra el futuro de la movilidad con PRINX llantas.'],
          more:'Más información sobre nuestras tecnologías',
          silenteck:{
            title:'Silenteck',
            description:['La exclusiva tecnología de absorción del sonido incluye una esponja ultrafina incrustada en la goma. Esta innovadora solución está diseñada para ofrecer una notable reducción del ruido en todas las frecuencias.','Silenteck™ redefine el rendimiento acústico, proporcionando un entorno más silencioso y confortable para diversas aplicaciones. Mejore su experiencia con la tecnología de vanguardia de PRINX, donde el silencio se une a la excelencia.']
          },
          healteck:{
            title:'Healteck',
            description:['Tecnología exclusiva de autocuración, con un compuesto especial de látex diseñado para reparar instantáneamente los pinchazos. Esta innovadora tecnología sirve de escudo protector para las llantas, protegiéndolos eficazmente contra los pinchazos y los reventones. Con Healteck™, PRINX garantiza una solución fiable y resistente, ofreciendo una mayor seguridad y longevidad para sus llantas en la carretera.']
          },
          inktech:{
            title:'Inktech',
            description:['Esta revolucionaria tecnología utiliza finas texturas para reflejar y absorber la luz varias veces, lo que da como resultado un aspecto más oscuro y profundo la llanta. Experimente el tacto aterciopelado de Inktech™, una característica que eleva significativamente la sensación premium de sus llantas. Con PRINX, adopte la innovación que no sólo mejora la estética, sino que también ofrece una mayor sensación de sofisticación en la carretera.']
          }
        },

        awards:{
          title:['Múltiples premios internacionales de diseño','ganador'],
          subtitle:['Descubra los premios y certificaciones que afirman la excelencia de nuestras llantas.','Cada galardón representa nuestro compromiso constante con la calidad, la seguridad y la innovación en el sector. Nos sentimos orgullosos de estar entre los líderes del mercado, gracias a la confianza de nuestros clientes y socios.'],
          ver_premio:'Ver premio',
          categoria: 'Categoría',
          premios:[
            {
              title:'A’Design Award & Competition',
              tire:'XNEX SPORT EV',
              place:'Italia - 2022',
              position:'Ganador',
              category_name:'Diseño de piezas de vehículos, accesorios y productos de cuidado del automóvil',
              description:'la llanta XNEX SPORT EV se enorgullece de haber obtenido los máximos honores en un prestigioso concurso internacional, que reconoce su excelencia e innovación. Podemos considerar la llanta XNEX SPORT EV como una goma avanzada que reduce la resistencia y el calor, mejorando la vida útil de la llanta y la eficiencia del motor eléctrico. La banda de rodadura optimizada minimiza el ruido para una conducción más silenciosa.'
            },
            {
              title:'DNA Paris Design Awards',
              tire:'XNEX SPORT EV',
              place:'París - 2022',
              position:'Ganador',
              category_name:'Diseño de productos - Vehículos, transporte y accesorios',
              description:'DNA Paris Design Awards, que celebra la excelencia en todas las disciplinas del diseño, es un acontecimiento importante en el ámbito del diseño. Como empresa tecnológica innovadora, nos sentimos privilegiados por haber participado en este prestigioso evento celebrado en París. Nos sentimos muy orgullosos de que XNEX SPORT EV haya conseguido un nuevo triunfo en la categoría de Diseño de Producto - Vehículos, Transporte y Accesorios.'
            },
            {
              title:'Muse Design Award',
              tire:'XNEX SPORT EV',
              place:'Nueva York - 2022',
              position:'Ganador',
              category_name:'Diseño de transporte - Accesorios e interiores de automóviles',
              description:'XNEX SPORT EV supera a las llantas EV tradicionales, sobresaliendo en durabilidad, silencio, eficiencia energética y maniobrabilidad. Su diseño exclusivo y su fórmula de compuestos han superado la prueba Ground Contact Efficiency, reduciendo el peso, el ruido y las vibraciones y mejorando la respuesta de la dirección. La innovadora composición del caucho minimiza el calor, reduce la resistencia y añade un toque estético con flancos de colores para una expresión artística y un fácil mantenimiento.'
            },

          ]
        },
        tud_suv:{
          subtitle:'Líder mundial en la prestación de servicios de certificación e inspección de calidad.',
          section:{
            title:'TÜV SÜD Alemania de un vistazo',
            text_history:'Desde 1866, nuestros fundadores se propusieron minimizar los riesgos tecnológicos y proteger a las personas, los activos y el medio ambiente. Más de 150 años después, la sostenibilidad y la seguridad siguen siendo fundamentales en nuestra misión. Nuestro objetivo es fomentar la confianza en la tecnología, gestionando los riesgos e impulsando el cambio. Plasmado en nuestro lema "Add value. Inspire trust", aspiramos a ser el socio preferido para soluciones de seguridad y sostenibilidad en todo el mundo. De cara al futuro, vemos la sostenibilidad y la digitalización como fuerzas clave que configuran el comercio y la sociedad. Más allá del cumplimiento normativo, infundimos confianza en los ámbitos físico y digital para un futuro más seguro y sostenible.',

            text_general:[
              'TÜV SÜD es una de las organizaciones de certificación más reconocidas a nivel mundial, que garantiza la seguridad y calidad de productos y servicios. En el ámbito de las llantas, TÜV SÜD realiza rigurosas pruebas para asegurar que cumplen con los estándares internacionales de seguridad y rendimiento.',
              'Las llantas certificadas por TÜV SÜD han pasado por exhaustivas evaluaciones que incluyen pruebas de durabilidad, resistencia al desgaste, adherencia en diferentes condiciones climáticas y más. Esta certificación es un sello de confianza para los consumidores que buscan productos de alta calidad y seguridad.',
              'En Mundo EV, nos enorgullece ofrecer llantas que cumplen con estos estándares exigentes, asegurando así la mejor experiencia de conducción para nuestros clientes.',
            ],

            resultados_title:'Resultado de pruebas de TÜV SÜD',
            result_text:'Para obtener más información sobre la certificación TÜV SÜD y cómo garantiza la calidad de nuestras llantas. Aquí puedes consultar los informes detallados y resultados de las pruebas realizadas por TÜV SÜD, que avalan la seguridad, durabilidad y desempeño de nuestras llantas.',
            see_btn: 'Descubrir los resultados'
          }
          
        },
        tire_knowledge:{
          title:'Información sobre llantas',
          subtitle:'Estamos orgullosos de la calidad y durabilidad de nuestras llantas. Aquí compartimos información sobre cómo comprar las llantas adecuadas, cómo cuidarlas correctamente, consejos para cambiarlas y montarlas, y mucho más. Manténgase informado para un viaje más suave y seguro. Porque en llantas, el conocimiento es clave para un rendimiento y una seguridad óptimos.',

          saber_mas:'Saber más',
          posts:[
            {
              hashtag:'#Conocimientos sobre llantas',
              title:'Definiciones básicas',
              subtitle:'Los fundamentos de las llantas y las ventajas del tubeless'
            },{
              hashtag:'#Conocimientos sobre llantas',
              title:'Cómo leer las llantas',
              subtitle:'Entender cómo funciona el dimensionado de las llantas es crucial'
            },{
              hashtag:'#Conocimientos sobre llantas',
              title:'Estructura de las llantas',
              subtitle:'Desvelando la anatomía la llanta y sus componentes clave para el rendimiento y la seguridad'
            },{
              hashtag:'#Uso diario',
              title:'¿Por qué es mejor utilizar llantas para vehículos eléctricos?',
              subtitle:'Elegir las llantas adecuadas para los vehículos eléctricos (VE) es crucial para aumentar su rendimiento'
            },{
              hashtag:'#Uso diario',
              title:'¿Cuál es la diferencia entre llantas?',
              subtitle:'Diferencias entre llantas de sedán, camión y SUV para un rendimiento y seguridad óptimos'
            },{
              hashtag:'#Uso diario',
              title:'¿Cuál debe ser la presión de las llantas en verano?',
              subtitle:'Garantizar una presión adecuada de las llantas durante los meses de verano es esencial.'
            },
          ]
        },

        about_us:{
          title:'POTENCIANDO LA MOVILIDAD ELÉCTRICA EN COSTA RICA',
          subtitle:['En Mundo EV, no solo vendemos llantas; impulsamos el futuro de la movilidad en Costa Rica. Creemos firmemente que cada kilómetro recorrido en un vehículo eléctrico no solo es eficiente, sino también una declaración de compromiso con nuestro planeta.','Es por eso que nos dedicamos a ofrecer soluciones especializadas y de vanguardia que elevan la experiencia de tu auto eléctrico.'],
          buttons:[
            'Compromisos','Valores','Qué ofrecemos','Empresa'
          ],
          empresa:{
            title:'Nuestra Historia: Visión y Experiencia Unida',
            description:[
              'Mundo EV nace de una visión clara y una oportunidad única en un mercado en plena efervescencia. Hemos combinado la experiencia internacional con un profundo conocimiento del panorama costarricense para fundar una empresa que no solo satisface una necesidad, sino que la anticipa.',
              'Nuestros socios fundadores, con décadas de trayectoria en campos complementarios, vieron la sinergia perfecta: aprovechar contactos globales, un vasto conocimiento del mercado europeo de llantas y la experiencia pionera en vehículos eléctricos en Costa Rica. Esta unión de saberes nos posiciona estratégicamente en el momento justo para liderar la oferta de productos de alta calidad para un sector que crece exponencialmente en nuestro país.'
            ]
          },
          compromisos:{
            title:'Nuestra Misión y Visión',
            description:[
              'Hacer que la operación de tu vehículo eléctrico en Costa Rica sea fácil, segura y eficiente, garantizando una movilidad sin preocupaciones para cada propietario.',
              'Para el año 2030, seremos la empresa líder y diversificada en soluciones para vehículos eléctricos en Costa Rica, reconocidos por nuestra excelencia, innovación y contribución al desarrollo sostenible del país.'
            ]
          },
          valores:{
            title:'El Núcleo de Nuestro Compromiso',
            description:'Cada decisión y cada interacción en Mundo EV se rigen por nuestros valores fundamentales:',
            list:[
              {
                title:'Integridad',
                information:'Actuamos con transparencia y honestidad en todo lo que hacemos.'
              },
              {
                title:'Responsabilidad',
                information:'Asumimos nuestro compromiso con nuestros clientes, el medio ambiente y la sociedad.'
              },
              {
                title:'Calidad',
                information:'Ofrecemos solo productos que cumplen con los más altos estándares y expectativas.'
              },
              {
                title:'Innovación',
                information:'Estamos en constante búsqueda de las mejores y más avanzadas soluciones para la movilidad eléctrica.'
              },
              {
                title:'Respeto',
                information:'Valoramos a nuestros clientes, colaboradores y al ecosistema en el que operamos.'
              },
            ]
          },
          que_ofrecemos:{
            title:'Productos Diseñados para tu EV',
            description:[
              'En Mundo EV, nos especializamos en productos pensados exclusivamente para vehículos eléctricos, asegurando un rendimiento óptimo y una operación sin igual.',
              'Inicialmente, nos enfocamos en llantas de alta gama, como nuestra marca Prinx, diseñadas específicamente para las exigencias de los vehículos eléctricos: mayor peso, alto torque y la necesidad de eficiencia y silencio. Estas llantas no solo prometen durabilidad y seguridad, sino que también contribuyen directamente a una mayor autonomía y confort de manejo.',
              'A medida que crecemos, ampliaremos nuestra oferta para incluir una gama de servicios y partes de excelente calidad, todos orientados a facilitar la operación y confiabilidad de tu vehículo eléctrico en Costa Rica.'
            ]
          },
          ubicacion:{
            title:'Sede Costa Rica',
          }
        },

        partners:{
          title:'Conviértase en distribuidor nacional de nuestros productos.',
          subtitle:[
            'Buscamos socios motivados que valoren la excelencia y la calidad para distribuir los productos PRINX en Costa Rica',
            'Complete el siguiente formulario para iniciar el proceso de asociación',
            'No pierdas esta oportunidad, únete a nuestra red de distribución.'
          ],
          next_steps_text:'Completa el siguiente formulario',
          company:{
            title:'Empresa - Compañia',
            placeholder:'Nombre de la empresa'
          },
          name:{
            title:'Nombre completo',
            placeholder:'Ingrese su nombre'
          },
          address:{
            title:'Dirección',
            placeholder:'Ingrese su direción'
          },
          phonenumber:{
            title:'Teléfono',
            placeholder:'Ingrese su número de teléfono'
          },
          email:{
            title:'Correo Eléctronico',
            placeholder:'Ingrese su dirección de correo eléctronico'
          },
          website:{
            title:'Sitio web',
            placeholder:'Ingrese su sitio web'
          },
          comments:{
            title:'Comentarios',
            placeholder:'Ingrese sus comentarios'
          },
          send_btn:{
            title:'Enviar'
          },
          success_message:'Su información fue enviada de manera satisfactoria.',
          error_message:'Su información no pudo ser enviada, por favor intentelo más tarde',
        },

        xnex_page:{
          general_titles:{
            categories:[
              'Vehículo',
              'Vehículo Eléctrico',
              'Verano'
            ],
            characteristics_title:'Características opcionales',
            buy_btn:'Comprar'
          },
          hero:{
            title:'XNEX SPORT EV',
            subtitle:'EV ULTRA HIGH PERFORMANCE ',
            description:'LIBÉRESE PARA DISFRUTAR DE UNA CONDUCCIÓN DEPORTIVA. LA EMOCIONANTE ELECCIÓN PARA VEHÍCULOS ELÉCTRICOS.',
          },
          second_section:{
            title:'Diseñado para vehículos eléctricos',
            description:'PRINX revoluciona la movilidad eléctrica con llantas especializadas para vehículos eléctricos. Diseñadas para una mayor autonomía y una tracción superior, estos llantas ecológicas ofrecen una conducción suave y silenciosa. Diseñadas pensando en la sostenibilidad, las llantas PRINX combinan innovación y conciencia medioambiental para ofrecer un viaje más ecológico.'
          },
          third_section:{
            title:'Técnologias de llantas XNEX SPORT EV',
            description:'Experimenta el futuro de la innovación en llantas con XNEX SPORT EV, equipada con tecnologías de última generación diseñadas para redefinir tu experiencia de manejo.',
            details:[
              'Experimenta el tacto aterciopelado de los moldes con grabado láser Inktech™. Esta tecnología revolucionaria utiliza texturas finas para reflejar y absorber la luz múltiples veces, logrando una apariencia de llanta más oscura y profunda.',
              'La espuma interior reduce el ruido de cavidad de baja frecuencia en hasta 12,6 dB y el ruido interior general en 1-2 dB sin comprometer otras prestaciones como la maniobrabilidad y el ahorro de combustible.',
              'Se aplica una capa de caucho autosellante bajo la banda de rodadura. Cuando se pincha, el caucho sellador fluirá hacia el punto dañado y evitará la fuga de aire, evitando así que la llanta reviente o pierda el control y mejorando la seguridad.',
            ]
          },
          fourth_section:{
            title:'PATRÓN DE HOMBROS',
            description:'Los bloques masivos y conectados de los hombros proporcionan un mejor apoyo en la conducción deportiva.'
          }
        },
        xlab_page:{
          general_titles:{
            categories:[
              'Vehículo',
              'Vehículo Eléctrico',
              'Verano'
            ],
            characteristics_title:'Características opcionales',
            buy_btn:'Comprar'
          },
          hero:{
            title:'XLAB CONFORT EV',
            subtitle:'ALTO RENDIMIENTO EV',
            description:'PARA VIAJES SILENCIOSOS Y CÓMODOS, INCLUSO EN UN ENTORNO HÚMEDO.',
          },
          second_section:{
            title:'Viaje tranquilo y cómodo',
            description:'XLAB Comfort EV Diseñados para ofrecer un agarre superior sobre mojado, una mayor vida útil de la banda de rodadura y un acabado aterciopelado.'
          },
          third_section:{
            title:'XLAB COMFORT EV Tecnologías de llantas',
            description:'Experimente el futuro de la innovación en llantas con el XLAB COMFORT EV con tecnologías de vanguardia diseñadas para redefinir su experiencia de conducción.',
            technologies:[
              'Silencio y comodidad gracias a un diseño único.',
              'Conducción segura en carreteras mojadas. Mejor agarre en mojado gracias a un nuevo e innovador compuesto de la banda de rodadura.',
              'Mayor duración de la banda de rodadura gracias al perfil optimizado para un desgaste uniforme.',
              'Belleza y singularidad de la pared lateral de terciopelo.',
              'Grado de etiquetado de primera clase.'
            ],
            details:[
              'Experimenta el tacto aterciopelado de los moldes con grabado láser Inktech™. Esta tecnología revolucionaria utiliza texturas finas para reflejar y absorber la luz múltiples veces, logrando una apariencia de llanta más oscura y profunda.',
              'La espuma interior reduce el ruido de cavidad de baja frecuencia en hasta 12,6 dB y el ruido interior general en 1-2 dB sin comprometer otras prestaciones como la maniobrabilidad y el ahorro de combustible.',
              'Se aplica una capa de caucho autosellante bajo la banda de rodadura. Cuando se pincha, el caucho sellador fluirá hacia el punto dañado y evitará la fuga de aire, evitando así que la llanta reviente o pierda el control y mejorando la seguridad.',
            ]
          },
          fourth_section:{
            title:'Diseño de hombro cerrado',
            description:'El hombro cerrado evita que salga el ruido de bombeo de la banda de rodadura y es más respetuoso con el medio ambiente.'
          },
          fifth_section:[
            {
              title:'PRINX Control y confort Equilibrio Teoría del equilibrio de las llantas',
              description:'Perfil de sección optimizado para cargas más pesadas a fin de evitar un desgaste irregular.'
            },
            {
              title:'Compuesto de la banda de rodadura para un rendimiento equilibrado',
              description:'Garantiza el agarre sobre mojado manteniendo su larga vida útil.'
            },
          ]
        },
        tire_search:{
          general_title:'Escoja categoría para realizar búsqueda',
          category:'Categoría',
          products:'Productos',
          car_model:'Modelo de vehículo',
          tire_size:'Medida de llanta',
          title:'Introduzca las médidas de las llantas',
          search_btn:'Buscar llanta',
          ancho:'Ancho',
          perfil:'Perfil',
          tamano_aro:'Tamaño de aro'
        },
        posts:{
          volver_text: 'Regresar',
          basic_definitions:{
            title:'Definiciones básicas',
            subtitle:'Los fundamentos de las llantas y las ventajas del tubeless',
            section_one:{
              body:[
                'Definición y función de la llanta',
                'La ETRTO( Organización Técnica Europea de Llantas) define una llanta como: "una llanta es un componente flexible del conjunto de la rueda, hecho de caucho y materiales de refuerzo. Inflar la llanta con gas comprimido le permite soportar la carga de la rueda como parte de la carga del eje y transmitir fuerzas longitudinales y transversales. En vacío, la llanta inflado es esencialmente toroidal".',
                {
                  title:'Carga',
                  body:'Contienen un volumen de aire presurizado para soportar la carga del vehículo'
                },
                {
                  title:'Proporcionar agarre',
                  body:'Transmiten las fuerzas de tracción y frenado a la calzada'
                },
                {
                  title:'Absorbe los golpes',
                  body:'Complementar la suspensión del vehículo (absorber los impactos de la superficie de la carretera).'
                },
                {
                  title:'Dirección de ayudas',
                  body:'Proporcionan estabilidad direccional mientras cambian o mantienen la dirección'
                },
              ]
            },
            section_two:{
              body:[
                'Ventajas de las llantas sin cámara',
                'La tecnología de llantas sin cámara elimina el uso de cámaras de aire. Una vez instalado, la llanta sin cámara sella herméticamente la llanta de la rueda.',
                {
                  title:'Fugas de aire lentas',
                  body:'Las fugas de aire son lentas en comparación con las llantas con cámara de aire	'
                },
                {
                  title:'Aumentar la seguridad',
                  body:'El conductor no pierde el control y puede tener más tiempo para moverse por la carretera o ir a la tienda de llantas más cercana en comparación con las llantas con cámara.'
                },
                {
                  title:'Ahorro de combustible',
                  body:'las llantas sin cámara son más ligeros debido a la ausencia de la cámara. Como resultado, se obtienen más kilómetros con la misma cantidad de combustible.'
                },
                {
                  title:'Menos fricción',
                  body:'La fricción que suele haber entre la llanta y la cámara de aire se elimina en las llantas sin cámara, de ahí que se reduzca la resistencia a la rodadura y se mejore la comodidad de conducción.'
                },
                {
                  title:'Uso de sellador',
                  body:'las llantas sin cámara modernos pueden venir con un sellador líquido, para una reparación automática de pinchazos, para evitar que salga el aire	'
                },
                {
                  title:'Confort de conducción',
                  body:'las llantas sin cámara permiten un asiento más preciso de la llanta en la rueda, una mayor uniformidad del conjunto en general y mejoran la capacidad de equilibrar el conjunto, lo que a la larga se traduce en una mayor comodidad de conducción en comparación con las llantas con cámara.'
                },
              ]
            }
            
          },
          how_to_read_tires:{
            title:'Cómo leer las llantas',
            subtitle:'Entender cómo funciona el dimensionado de las llantas es crucial',
            body:[
              'Entender cómo funciona el dimensionado de una llanta es crucial antes de comprar una nuevo. Como se ilustra en el diagrama siguiente, toda la información necesaria se encuentra en la llanta.',
              'Lateral de la llanta',
              'Índice de carga: la capacidad máxima de carga de la llanta, según la tabla de índices de carga. En este escenario 94 está relacionado con 670kg como carga máxima.',
              'Índice de velocidad: la velocidad máxima permitida para la llanta. Como puede ver en la tabla siguiente, V significa 240 km/h (150 mph)',
              'Designación del tamaño de la llanta: una llanta de tamaño 215/55R17 indica una anchura de la sección transversal de 215 mm, 55 indica una relación altura/anchura del 55% (la relación entre la altura lateral de la llanta y la anchura de la sección transversal H/S) y R es el código estructural de las llantas radiales. 17 es el diámetro de la llanta, expresado en pulgadas.',
              [
                '215: anchura nominal de la sección de la llanta',
                '55: relación de aspecto nominal',
                'R: código del constructor radial',
                '17: diámetro nominal de la llanta (pulg.)',
                '94: índice de carga (capacidad de carga 670 kg)',
                'V: índice de velocidad de la llanta (V = velocidad máxima de funcionamiento 240 km/h o 150 mph)'
              ],
              'Índice de velocidad de la llanta',
              'El índice de velocidad indica la velocidad óptima que la llanta puede mantener con seguridad a lo largo del tiempo, es decir, la velocidad máxima que una llanta puede soportar antes de dejar de funcionar como fue diseñada. Cuanto mayor sea el índice de velocidad, mejor control y maniobrabilidad tendrás a velocidades más altas.'
            ]
          },
          tire_structure:{
            title:'ESTRUCTURA DE LA LLANTA',
            subtitle:'Anatomía de las llantas tubulares y sus componentes claves para el rendimiento y la seguridad',
            body:[
              'Comprender la estructura de una llanta es esencial para apreciar su impacto en el rendimiento general del vehículo. Desde capas de materiales avanzados hasta intrincados dibujos de la banda de rodamiento, en la compleja anatomía de la llanta  contribuye cada elemento a un manejo seguro y eficiente.',
              'COMPONENTES DE UNA LLANTA RADIAL',
              
              '1: BANDA DE RODAMIENTO / TACO',
              'Está compuesto por una gruesa capa de caucho que entra en contacto directo con la superficie de la carretera. Está diseñado para ser altamente resistente a la fractura y al impacto, con el objetivo de proteger la carcasa y las capas situados en el interior de la llanta. Cada marca emplea cauchos y mezclas secretas propias con características especiales para aumentar por ejemplo el agarre y la vida útil general del producto, de alta tecnología para las necesidades de los EV. Su dibujo igualmente contribuye a la capacidad para extraer agua y mejorar tracción y frenado.',

              '2 Y 3: HOMBRO Y PARED LATERAL (FLANCO) / PERFIL',
              'Situado entre el hombro y el talón de la llanta, el flanco protege la carcasa y mejora la calidad de manejo gracias a sus movimientos flexibles de extensión y contracción. Además, esta sección de la llanta contiene información importante, como el tipo de llanta, las normas, dimensión, la fecha de fabricación, el nombre del fabricante y el modelo.',
              
              '4 Y 9: TALÓN Y PESTAÑA',
              'El talón rodea el extremo del cordón, fijando la llanta al aro. Comprende varios componentes, como el alambre del talón, el núcleo, el caucho y la aleta. Normalmente, el aro se aprieta ligeramente para evitar que la llanta se desenganche en caso de una reducción repentina de la presión del aire durante la conducción.',

              '5: CARCASA',
              'El armazón, la parte más importante que controla la presión interna y mantiene la forma de la llanta, absorbiendo el peso y los impactos. Especial en llantas EV.',

              '6: PROTECTOR / CORREA',
              'Unas cuerdas reforzadas a base de nylon, kevlar, etc. se incrustan en una capa de hule y se colocan alrededor de la circunferencia de la llanta. Especial en llantas EV.',

              '7: AISLAMIENTO INTERIOR',
              'El revestimiento interior sustituye a la cámara (llanta)  en el interior de la llanta y consta de una capa de caucho con excelentes propiedades herméticas que retienen el aire. Se conocen como tubulares. Normalmente, el caucho es de butilo, caucho sintético o poliisopreno. Ver tecnología silentek y healtek de PRINX.',

              '8: PLIEGES DE ACERO Y NYLON',
              'Múltiples cinturones con cables de acero en ángulo para crear una base para la banda de rodamiento, presionándola contra la carretera para un desgaste lento y uniforme, alta tracción y maniobrabilidad. Hecho de acero de alta resistencia, se aplica en la parte superior de la capa de la carcasa. En las llantas de vehículos de pasajeros, construcción de 2 capas o más. Los materiales utilizados son mezclas secretas de cada fabricante y difieren en cada modelo, según cuál sea el uso de la llanta o para qué tipo de vehículo (ejemplo EV).'
            ]
          },
          use_ev_tires:{
            title:'¿Por qué es mejor utilizar llantas para vehículos eléctricos?',
            subtitle:'Elegir las llantas adecuadas para los vehículos eléctricos (VE) es crucial para aumentar su rendimiento',
            body:[
              'En términos generales, la razón por la que la gente elige los BEV es que, en comparación con los ICEV (vehículos con motor de combustión interna), los BEV tienen unos costes de conducción más bajos y una mejor experiencia de conducción. Además, los conductores pueden contribuir al cambio climático conduciendo un BEV.',
              'La mayor diferencia entre el BEV y el ICEV es el modo de conducción. El ICEV depende principalmente del motor y la transmisión para conducir, mientras que el modo de conducción del BEV es la batería, lo que conlleva un mayor peso del BEV y afecta directamente al desgaste de las llantas y a la distancia de frenado. Por lo tanto, se requiere que las llantas tengan un mayor rendimiento en términos de frenado y desgaste.',
              'Mientras tanto, como los usuarios esperan que el BEV recorra distancias más largas con cada carga, la llanta necesita mejorar el rendimiento en términos de resistencia a la rodadura. Dado que el motor del BEV tiene características de alto par, para aprovechar al máximo las prestaciones del motor es necesario utilizar llantas con mejores prestaciones de agarre.',
              'Además, aunque el BEV no tiene el ruido mecánico generado por el motor y el sistema de transmisión, la gente podría seguir oyendo el ruido de las llantas. Para reducir el ruido general, las llantas deben ser capaces de absorber las vibraciones y el ruido de las carreteras en mal estado para que la conducción sea más silenciosa y cómoda.'
            ]
          },
          whats_difference:{
            title:'¿Cuál es la diferencia entre llantas?',
            subtitle:'Diferencias entre llantas de vehículo liviano, camión y SUV para un rendimiento y seguridad óptimos',
            body:[
              'El enfoque de "talla única" puede ser práctico para usted, pero rara vez funciona para los vehículos, sobre todo a la hora de elegir llantas.',
              'Los distintos llantas de coche se utilizan para diferentes aplicaciones y entornos de conducción. Comprender los tipos de llantas, su uso en diversas situaciones y las justificaciones técnicas de por qué se adaptan a determinados coches te ayudará a elegir la llanta ideal.',
              'La parte más adaptable de un coche es su llanta, y existen ligeras variaciones entre las llantas de SUV, camión y vehículo liviano. El juego de llantas adecuado para un vehículo a menudo puede ser complejo de decidir para los propietarios.',
              'Aunque la mayoría de los propietarios de automóviles los utilizan indistintamente, las llantas de los vehículos livianos y los de los SUV están diseñados para funcionar de forma diferente. Mientras que los segundos están diseñados para trabajos más exigentes y pesos más elevados, los primeros se utilizan para transportar pasajeros y carga.',
              {
                title:'Llantas de Automóvil',
                body:[
                  'las llantas para vehículos livianos están diseñados para berlinas, monovolúmenes y todoterrenos. Estos llantas ofrecen una conducción silenciosa y cómoda, una tracción excelente y una banda de rodadura duradera. Las furgonetas grandes, los todoterrenos y los vehículos pesados no deberían tener instalados estos llantas debido a su estructura ligera, que los hace inadecuados para transportar cargas enormes.',
                  'La mayoría de los modelos de llantas para vehículos livianos son para todas las estaciones y ofrecen excelentes índices de kilometraje en carretera. La mayoría de las llantas de vehículo liviano para todas las estaciones también deberían incluir un indicador M+S para mostrar su capacidad para todas las estaciones. Mucha gente se pregunta: ¿puedo poner llantas de vehículo liviano en un SUV? La respuesta es sí.',
                ]
              },
              {
                title:'llantas para camiones ligeros',
                body:[
                  'las llantas para camiones ligeros o LT-metric cuentan con flancos más rígidos y bandas de rodadura más profundas que las llantas P-metric. Además, gracias a su estructura "más pesada", se adaptan mejor a terrenos difíciles y a la elevación de cargas voluminosas.',
                  'las llantas LT-métricos ofrecen un manejo más extraordinario cuando se transportan suministros o equipos voluminosos, lo que los convierte en la opción preferida para camiones y SUV fiables.'
                ]
              },
              {
                title:'llantas SUV',
                body:[
                  'las llantas para SUV están diseñados para ser más adaptables y capaces que los típicos llantas para vehículos livianos. Están hechos para gestionar exigentes operaciones de arrastre y transportar grandes cargas. Además, deben ser flexibles cuando sea necesario. Por ello, tienen diseños más duraderos para su uso en terrenos accidentados.',
                  'A la hora de comprar llantas para SUV, siempre se recomienda a los conductores que tengan en cuenta la capacidad del vehículo para transportar cargas. Intente siempre alinear la carga máxima deseada con los índices de carga. Estos llantas están diseñados para circular por carreteras invernales, embarradas o de grava y contienen compuestos de caucho gruesos y bandas de rodadura agresivas.',
                  'Ofrecen mejor tracción y pueden resistir los golpes. Dependiendo de si conduce principalmente por carretera o fuera de ella, hay varios llantas para SUV entre los que elegir. El uso de tacos agresivos en la banda de rodadura cuando se viaja o se conduce por asfalto los hace increíblemente rígidos e incómodos. También degradan gravemente la forma en que se maneja el vehículo.'  
                ]
              },
              {
                title:'llantas de camión frente a llantas de SUV',
                body:[
                  '¿Cuál es la diferencia entre las llantas de camión y los de SUV? En comparación con las llantas para SUV, las llantas para camión suelen ser más agresivos, tienen un flanco más alto y están certificados para soportar pesos más elevados. A pesar de esto, muchos llantas de camión están disponibles en tamaños de SUV, lo que hace difícil distinguir claramente entre llantas de camión y SUV en términos de tamaño de llanta.',
                  'Algunos camiones contemporáneos aceptan llantas más frecuentemente de tamaño SUV, mientras que algunos SUV utilizan llantas "tamaño camión". El diseño de la llanta y sus principales ventajas son las distinciones fundamentales entre una llanta de camión y uno de SUV.'
                ]
              },
              {
                title:'llantas para vehículos livianos frente a llantas para camiones ligeros',
                body:[
                  'Además, debe conocer la diferencia entre las llantas para vehículos livianos y las llantas para camiones ligeros (LT). Los camiones pueden acomodar ambos tamaños LT, pero los SUV casi nunca lo hacen. En comparación con las llantas para vehículos livianos, las llantas LT pueden soportar cargas más elevadas.',
                  'las llantas para camiones ligeros suelen tener un compuesto de goma más grueso que otros llantas, lo que los hace más duraderos. Sin embargo, suelen costar más que las llantas de los camiones de pasajeros. las llantas LT pueden no ofrecer una conducción tan suave como los de los camiones de pasajeros. También son más fáciles de encontrar y menos caros. Sin embargo, no pueden transportar grandes pesos.'
                ]
              },
            ]
          },
          tire_presure:{
            title:'¿Cuál debe ser la presión de las llantas en verano?',
            subtitle:'Garantizar una presión adecuada de las llantas durante los meses de verano es esencial.',
            body:[
              'La presión de las llantas es un factor esencial para garantizar una conducción suave y sin problemas. El aire del interior de las llantas es sensible a los cambios de temperatura. Por eso es importante vigilar la presión de las llantas y si es la ideal para la carretera y el coche en cuestión.',
              'Aunque la presión de las llantas puede permanecer constante durante todo el año, no ocurre lo mismo en lugares con cambios frecuentes de temperatura o si se va de viaje y cosas por el estilo.',
              {
                title:'¿Cuál debe ser la presión de las llantas?',
                body:[
                  'La presión ideal de las llantas de cada coche es diferente. Para obtener la medida más precisa, se recomienda consultar al fabricante. En general, un aumento de 10 grados Fahrenheit provoca un aumento de 1 libra por pulgada cuadrada (psi) de diferencia en la presión del aire.',
                  'La temperatura normal a la que la presión de las llantas es más o menos regular es de 20 grados centígrados. Tanto el inflado excesivo como el insuficiente pueden causar inconvenientes, en el mejor de los casos, y graves accidentes de tráfico, en el peor. En general, la presión recomendada para las llantas de los coches es de 30 a 35 psi.',
                  'Durante los veranos, con el aumento de la temperatura, el aire del interior de la llanta se expande. Debido a ello, suele producirse un inflado excesivo. En casos extremos, la llanta puede incluso reventar si el aire que contiene se expande demasiado. Sin embargo, siempre se recomienda reducir la presión de la llanta sólo cuando éste se enfríe. De este modo, la presión ideal de las llantas puede alcanzarse con mayor precisión, ya que los fabricantes suelen indicar la presión para llantas fríos.',
                  'La Organización Técnica Europea de llantas y Llantas (ETRTO 2001) también sugirió que la presión en caliente puede ser hasta un 20% superior a la de las llantas en frío y que, en ningún caso, las llantas en caliente deben someterse a la presión recomendada para las llantas en frío por los fabricantes de automóviles.'
                ]
              },
              {
                title:'¿Cómo comprobar la presión de las llantas?',
                body:[
                  'Debe comprobar regularmente la presión de las llantas para controlar la presión del aire. Cuando es una medida ideal, no sólo es seguro, sino que también garantiza una conducción suave. Aunque siempre puede comprobar la presión de las llantas en el taller o surtidor de gasolina más cercano, también puede hacerlo en casa.',
                  'Estos son los pasos para comprobar la presión de las llantas en casa:',
                  [
                    'Asegúrese de que la llanta está frío. Esto se puede conseguir si no se ha conducido durante al menos tres horas.',
                    'Compruebe la medida ideal proporcionada por el fabricante para el modelo de su coche. Suele aparecer en la etiqueta interior de todos las llantas.',
                    'Consigue un manómetro. Con él, retira el tapón de la llanta y fíjalo al vástago del manómetro.',
                    'Presione la llanta para eliminar el exceso de aire. Esto se entiende por el silbido que se produce. Siga presionando hasta que el silbido del aire se reduzca.',
                    'Espere a que la lectura del manómetro se estabilice y compárela con la mencionada por su fabricante.',
                    'Si la lectura es más alta, tendrás que dejar salir algo de aire; si es más baja de lo recomendado, tendrás que introducir más aire. Asegúrate de hacerlo en pequeñas dosis con comprobaciones continuas para no pasarte.'
                  ],
                  'Asegúrese de comprobar todos las llantas de su vehículo. La diferencia de presión de uno solo puede tener un gran impacto y provocar accidentes. Si le revisan las llantas en un surtidor de gasolina, es probable que su vehículo no esté en las condiciones de refrigeración necesarias. Asegúrese de ajustar su psi en consecuencia.'
                ]
              }
            ]
          }

        },
        privacy_policy:{
          titulo: "Política de Privacidad",
          introduccion: "En nuestro sitio web respetamos su privacidad y protegemos sus datos personales. Esta política explica cómo recopilamos, usamos y protegemos su información.",
          recopilacion_datos: "Recopilamos información como nombre, correo electrónico, número de teléfono y dirección de envío únicamente para procesar sus pedidos.",
          uso_datos: "La información recopilada se utiliza exclusivamente para brindar nuestros servicios, contactar al cliente y mejorar su experiencia de compra.",
          proteccion_datos: "Implementamos medidas de seguridad para proteger sus datos contra el acceso no autorizado, pérdida o alteración.",
          terceros: "No compartimos su información personal con terceros, excepto cuando sea necesario para completar el proceso de compra (por ejemplo, servicios de mensajería).",
          derechos_usuario: "Usted tiene derecho a acceder, corregir o eliminar su información personal en cualquier momento.",
          contacto: "Para consultas sobre esta política, contáctenos a través de nuestro correo electrónico de atención al cliente."
        }, 
        cookies_policy:{
          title:'Política de Cookies',
          introduction: "En nuestro sitio web, utilizamos cookies para mejorar la experiencia del usuario y ofrecer contenido personalizado. Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo y que nos ayudan a recordar información sobre ti y tus preferencias.",
          types_of_cookies: "Tipos de Cookies que utilizamos:",
          technical_cookies: "Estas cookies son esenciales para el funcionamiento básico de nuestro sitio web, como mantener tu sesión activa o permitirte navegar por las diferentes páginas.",
          analytics_cookies: "Utilizamos herramientas de análisis, como Google Analytics, para recopilar información sobre cómo utilizas nuestro sitio. Esto nos ayuda a entender qué áreas son populares, cómo podemos mejorar la navegación y la experiencia del usuario en general.",
          advertising_cookies: "Podemos utilizar cookies para mostrarte anuncios que sean relevantes para tus intereses. Estas cookies pueden ser colocadas por nosotros o por terceros, como redes sociales o empresas de publicidad.",
          cookie_management: "Puedes gestionar las cookies a través de la configuración de tu navegador. Puedes optar por bloquear todas las cookies, aceptar solo algunas o eliminarlas por completo. Ten en cuenta que si desactivas las cookies, algunas funcionalidades de nuestro sitio web podrían no funcionar correctamente.",
          consent: "Al visitar nuestro sitio web, aceptas el uso de cookies técnicas. Si deseas utilizar cookies de análisis o publicidad, te solicitaremos tu consentimiento antes de instalarlas en tu dispositivo.",
          contact: "Si tienes alguna pregunta sobre nuestra política de cookies, no dudes en contactarnos a través de [dirección de correo electrónico o formulario de contacto].",
          updates: "Nos reservamos el derecho de actualizar esta política de cookies en cualquier momento. Te notificaremos sobre cualquier cambio importante a través de nuestro sitio web."
        },
        comingSoonEcommerce:{
          title:'¡Gracias por preferirnos!',
          body: 'Muy pronto en nuestra tienda online con los mejores precios en llantas para tu vehículo eléctrico.',
          button_text:'Visítanos en Facebook'

        },
        termsOnlineSale:{
          title:'Términos y Condiciones de Venta de Llantas en Línea',
          subtitle:'Última actualización: 23 de julio de 2025',
          sections:[
            {
              title:'1. Aceptación de los Términos',
              body:[
                'Al acceder y usar este sitio web, www.prinxcr.com, Usted reconoce haber leído, entendido y aceptado estos Términos y Condiciones en su totalidad.',
                'Si no está de acuerdo con alguna de las cláusulas, por favor no utilice nuestros servicios.'
              ]
            },
            {
              title:'2. Definiciones',
              body:[
                'Cliente: Persona física o jurídica que realiza compras en el sitio.',
                'Vendedor: Mundo EV S.A., responsable de la comercialización de llantas.',
                'Producto: Cualquier llanta o accesorio disponible para la venta.',
                'Pedido: Solicitud de compra formalizada a través de la plataforma.'
              ]
            },
            {
              title:'3. Registro y Cuenta de Usuario',
              body:[
                'Para efectuar compras, el cliente debe crear una cuenta proporcionando datos verídicos.',
                'El cliente es responsable de mantener la confidencialidad de su usuario y contraseña, así como de todas las actividades que se realicen bajo su cuenta.',
                'Nos reservamos el derecho de suspender o cancelar cuentas en caso de detectar uso indebido o fraude. El sitio de comercio electrónico www.prinxcr.com solamente permite realizar compras a usuarios que ingresen desde Costa Rica.'
              ]
            },
            {
              title:'4. Proceso de Compra',
              body:[
                'Seleccione el o los productos y añádalos al carrito.',
                'Complete los datos de facturación y envío.',
                'Elija el método de pago y confirme la operación.',
                'Recibirá un correo de confirmación con el resumen de su pedido.',
                'El pedido queda sujeto a disponibilidad hasta la confirmación del pago.'
              ]
            },
            {
              title:'5. Precios, Promociones y Formas de Pago',
              body:[
                'Los precios se expresan en colones e incluyen los impuestos aplicables.',
                'Las promociones tienen fechas de vigencia y condiciones específicas; su aplicación estará sujeta a términos de cada oferta.',
                'Métodos de pago aceptados:',
                'Tarjetas de crédito / débito',
                'En caso de error tipográfico en el precio, nos reservamos el derecho de cancelar el pedido y reembolsar al cliente.'
              ]
            },
            {
              title:'6. Envíos y Entregas',
              body:[
                'Ofrecemos cobertura en la mayor parte del territorio de Costa Rica. Los plazos estimados son:',
                'Zona Plazo de entrega estimado',
                'GAM ',
                '1-3 días hábiles',
                'Zona Rural ',
                '3-5 días hábiles',
                'Los plazos de entrega indicados se cumplirán en la mayoría pero son una referencia, la fecha de entrega será suministrada en el momento en que se le confirme el pedido por medio de correo electrónico.',
                'El cliente debe revisar el estado del paquete al momento de la entrega y reportar daños o faltantes en un plazo de 24 horas. El cliente autoriza debidamente a otras personas, que se encuentren en la dirección de entrega, a recibir su pedido.',
                'El costo del envío le será indicado en el momento de generar el pedido y debe ser cancelado con la compra del producto.'
              ]
            },
            {
              title:'7. Devoluciones, Cambios y Garantías',
              body:[
                'No se aceptan devoluciones ni cambios de nuestros productos, sin embargo, MUNDO EV se reserva el derecho de que en casos especiales y a su total discreción pueda aceptar cambio o devoluciones de productos.',
                'En caso de darse esta situación, los costos de devolución correrán a cargo de quien solicite el cambio, salvo defecto de fábrica.',
                'Las llantas cuentan con 30 (treinta) días de garantía del fabricante, a partir de la fecha de compra; esta garantía está limitada a desperfectos y/o danos de fábrica, no aplica por desgaste normal, golpes, rayaduras, danos físicos, alteraciones, instalación incorrecta o uso inadecuado.',
                'Para tramitar una reclamación, el cliente debe enviar copia de factura y fotografías del producto al correo electrónico info@evmundo.com e indicar en qué consiste el reclamo o inconformidad con la calidad del producto que desea plantear.'
              ]
            },
            {
              title:'8. Propiedad Intelectual',
              body:[
                'Todos los contenidos del sitio (textos, imágenes, logotipos, marcas) están protegidos por la legislación de propiedad intelectual.',
                'Queda prohibida la reproducción total o parcial sin autorización expresa de Mundo EV S.A.'
              ]
            },
            {
              title:'9. Privacidad y Protección de Datos',
              body:[
                'Tratamos sus datos personales conforme a nuestra Política de Privacidad, la cual puede consultar en esta página.'
              ]
            },
            {
              title:'10. Uso de Cookies',
              body:[
                'Utilizamos cookies para mejorar la experiencia de navegación y ofrecer contenido personalizado.',
                'El cliente puede desactivar las cookies desde las opciones de su navegador, aunque algunas funciones del sitio podrían no funcionar correctamente.'
              ]
            },
            {
              title:'11. Limitación de Responsabilidad',
              body:[
                'Mundo EV S.A. no será responsable por:',
                'Daños indirectos, lucro cesante o pérdidas derivadas del uso del sitio.',
                'Retrasos causados por fuerza mayor o proveedores de transporte.',
                'Nuestra responsabilidad máxima se limita al valor del pedido correspondiente.'
              ]
            },
            {
              title:'12. Modificaciones de los Términos ',
              body:[
                'Podemos actualizar estos Términos en cualquier momento.',
                'Los cambios se publicarán en esta página con la fecha de última actualización.',
                'El uso continuado del sitio después de la publicación de modificaciones implica la aceptación de las nuevas condiciones.'
              ]
            },
            {
              title:'13. Legislación Aplicable y Jurisdicción',
              body:[
                'Estos Términos se rigen por las leyes de la República de Costa Rica.',
                'Para la resolución de conflictos, ambas partes se someten a la jurisdicción de los tribunales de la Ciudad de San José.'
              ]
            },
            {
              title:'14. Contacto y Atención al Cliente',
              body:[
                'Si tiene dudas o requiere asistencia, puede comunicarse con nosotros:',
                'Correo electrónico: info@prinxcr.com',
                'Horario de atención: Lunes a Viernes, 9:00 - 18:00',
                'Gracias por elegirnos. ¡Rodemos juntos!'
              ]
            },
          ]
        }


      },
      en: {
        navbar:{
          home: 'Home',
          about_us:'About us',
          llantas:  {
            title: 'Products',
            section: 'Type of vehicle',
            //subtitle: 'Electric vehicle',
            subtitle: 'Tire list',
            charger_title:'EV Chargers'
          },
          information:{
            title: 'Information',
            tecnologia: 'Technology',
            premios: 'Design awards',
            informacion: 'Information about tires',
            tuv_sud: 'TÜV SÜD Germany',
          },
          comprar_btn: ['Buy', 'Tires'],
        },
        home: {
          title: [
            "Power up your electric vehicle with the quality and support of the experts!","Explore our range of products today and take your driving experience to the next level with PRINX.","A brand that ","LEAVES A MARK."
          ],
          partners: {
            title: 'We work with the best.',
          },
          tires: {
            xlab: {
              title: "XLAB Comfort EV",
              subtitle: "Quiet and comfortable, even on wet roads.",
              button_text: "More"
            },
            xnex: {
              title: "XNEX Sport EV",
              subtitle: "The thrilling option for electric vehicles.",
              button_text: "More"
            }
          },
          social: {
            title: ["Want more information about", "our products"],
            subtitle: "Follow us on social media to stay updated on all the latest news and product launches."
          },
          distributor_banner: "Exclusive Distributor For Costa Rica - MundoEV",
          future: {
            title: "Sustainable Future",
            subtitle: "Driving electric mobility and innovation for a cleaner, more sustainable world. Join the green revolution and be part of the change.",
            more_info_btn: "More information"
          },
          awards: {
            title: ["Winner", " of several international design awards"],
            events: [
              {
                title: "A'DESIGN AWARD & COMPETITION",
                country: "Italy"
              },
              {
                title: "MUSE DESIGN AWARDS",
                country: "USA"
              },
              {
                title: "PARIS DESIGN AWARDS 2022",
                country: "France"
              }
            ]
          },
          details: {
            subtitle: "AT THE FOREFRONT OF INNOVATION",
            title: "PRINX has established a virtuous circle of innovation to deliver high-performance tires",
            details: [
              {
                title: "TECHNOLOGY",
                description: [
                  "Our innovations offer more than performance: they ensure safer journeys, greater comfort, and a greener future.",
                  "By integrating advanced technology, safety measures, and eco-friendly materials, we're not just competing.",
                  "We are setting a NEW STANDARD FOR THE INDUSTRY."
                ],
                more_info_btn: "see more"
              },
              {
                title: "Performance",
                description: [
                  "Technology is at the core of our vision, driving development, competitiveness, and long-term success. We are committed to pushing the boundaries of advancement in the tire industry, using materials and technologies to create safer, more durable, and eco-friendlier tires. Discover the future of electric mobility."
                ],
                more_info_btn: "see more"
              },
              {
                title: "TÜV SÜD Certification",
                description: [
                  "We are committed to sustainability by using eco-friendly materials and responsible manufacturing processes, reducing environmental impact at every stage of the tire’s lifecycle. Through the integration of smart technologies, such as real-time monitoring sensors, our tires provide superior safety and adaptive performance.",
                  "With PRINX, innovation drives us to anticipate future needs, developing products that not only meet but exceed the expectations of the most demanding drivers."
                ],
                more_info_btn: "see more"
              }
            ]
          }
        },
        footer: {
          newsletter: {
            title: "Get on board",
            placeholder: "Enter your email address",
            suscribe_btn: "Subscribe",
            success_message: 'You have successfully subscribed.',
            error_message: 'The request could not be completed, please try again.'
          },
          titles: {
            tire_product: "TIRE BY PRODUCT",
            tire_vehicule: "TIRE BY VEHICLE",
            who_we_are: "Who we are",
            about: "About",
            policy_cookies: "Cookie Policy",
            policy_privacy: "Privacy Policy",
            terms_conditions:'Terms and conditions',
            distributor_title: "DISTRIBUTORS",
            distributor_text: "Become a distributor",
            distribuidores_autorizados: 'We are authorized distributors'

          },
          copyright: "Mundo EV - All rights reserved.",
          developer: "Developed and implemented by",
        },
        electric_vehicule:{
          title: 'Why Choose Mundo EV?',
          description: 'At Mundo EV, we are the experts in Electric Mobility solutions. Every product we offer, starting with our PRINX tires, is specifically designed for your electric vehicle, ensuring superior performance, greater comfort, and maximum safety.',
          subtitle: 'Our products not only meet but exceed the demanding standards and certifications required in markets such as Europe and the United States.',

          xnex:{
            title: 'XNEX SPORT EV',
            description: 'The thrilling option for electric vehicles.'
          },
          xlab:{
            title: 'XLAB COMFORT EV',
            description: 'Quiet and comfortable, even on wet roads.'
          }
        },

        technology:{
          title: 'PRINX Revolutionary Technologies',
          subtitle: [
            'At PRINX, technology is at the core of our vision, driving development, competitiveness, and lasting success.',
            'Our cutting-edge Technology Center, staffed by experts, is dedicated to pushing the boundaries of tire industry advancements. Explore new products, materials, and technologies that make your tires safer, more durable, and eco-friendly. Discover the future of mobility with PRINX tires.'
          ],
          more: 'More information about our technologies',
          silenteck:{
            title: 'Silenteck',
            description: [
              'The exclusive sound-absorbing technology includes an ultra-thin sponge embedded in the rubber. This innovative solution is designed to significantly reduce noise across all frequencies.',
              'Silenteck™ redefines acoustic performance, providing a quieter and more comfortable environment for various applications. Enhance your experience with PRINX’s cutting-edge technology, where silence meets excellence.'
            ]
          },
          healteck:{
            title: 'Healteck',
            description: [
              'Exclusive self-healing technology, with a special latex compound designed to instantly repair punctures. This innovative technology acts as a protective shield for tires, effectively defending them against punctures and blowouts. With Healteck™, PRINX guarantees a reliable and durable solution, offering greater safety and longevity for your tires on the road.'
            ]
          },
          inktech:{
            title: 'Inktech',
            description: [
              'This revolutionary technology uses fine textures to reflect and absorb light multiple times, resulting in a darker and deeper appearance of the tire. Experience the velvety feel of Inktech™, a feature that significantly elevates the premium sensation of your tires. With PRINX, embrace innovation that not only enhances aesthetics but also delivers a heightened sense of sophistication on the road.'
            ]
          }
        },

        awards:{
          title: ['Multiple international design awards', 'winner'],
          subtitle: [
            'Discover the awards and certifications that affirm the excellence of our tires.',
            'Each award represents our ongoing commitment to quality, safety, and innovation in the industry. We are proud to be among the market leaders, thanks to the trust of our customers and partners.'
          ],
          ver_premio: 'See award',
          categoria: 'Category',
          premios:[
            {
              title: 'A’Design Award & Competition',
              tire: 'XNEX SPORT EV',
              place: 'Italy - 2022',
              position: 'Winner',
              category_name: 'Vehicle parts design, accessories, and automotive care products',
              description: 'The XNEX SPORT EV tire proudly received top honors in a prestigious international competition, recognizing its excellence and innovation. We consider the XNEX SPORT EV a next-generation tire that reduces resistance and heat, enhancing tire life and electric motor efficiency. The optimized tread minimizes noise for a quieter ride.'
            },
            {
              title: 'DNA Paris Design Awards',
              tire: 'XNEX SPORT EV',
              place: 'Paris - 2022',
              position: 'Winner',
              category_name: 'Product Design - Vehicles, Transportation, and Accessories',
              description: 'DNA Paris Design Awards, celebrating excellence across all design disciplines, is a major event in the design field. As an innovative tech company, we were privileged to participate in this prestigious event held in Paris. We are extremely proud that XNEX SPORT EV achieved another victory in the Product Design - Vehicles, Transportation, and Accessories category.'
            },
            {
              title: 'Muse Design Award',
              tire: 'XNEX SPORT EV',
              place: 'New York - 2022',
              position: 'Winner',
              category_name: 'Transportation Design - Automotive Accessories and Interiors',
              description: 'XNEX SPORT EV surpasses traditional EV tires, excelling in durability, quietness, energy efficiency, and handling. Its exclusive design and compound formula passed the Ground Contact Efficiency test, reducing weight, noise, and vibration while enhancing steering response. The innovative rubber composition minimizes heat, reduces resistance, and adds an aesthetic touch with colored sidewalls for artistic expression and easy maintenance.'
            }
          ]
        },

        tud_suv:{
          subtitle: 'World leader in providing certification and quality inspection services.',
          section:{
            title: 'TÜV SÜD Germany at a Glance',
            text_history: 'Since 1866, our founders aimed to minimize technological risks and protect people, assets, and the environment. Over 150 years later, sustainability and safety remain central to our mission. Our goal is to build trust in technology by managing risks and driving change. As stated in our motto "Add value. Inspire trust", we aspire to be the preferred partner for safety and sustainability solutions worldwide. Looking ahead, we see sustainability and digitalization as key forces shaping business and society. Beyond compliance, we instill trust in both the physical and digital realms for a safer and more sustainable future.',

            text_general: [
              'TÜV SÜD is one of the most recognized certification organizations globally, ensuring the safety and quality of products and services. In the tire industry, TÜV SÜD conducts rigorous testing to ensure compliance with international safety and performance standards.',
              'Tires certified by TÜV SÜD undergo extensive evaluations, including durability testing, wear resistance, grip in various weather conditions, and more. This certification is a mark of trust for consumers seeking high-quality, safe products.',
              'At Mundo EV, we are proud to offer tires that meet these demanding standards, ensuring the best driving experience for our customers.'
            ],

            resultados_title: 'TÜV SÜD Test Results',
            result_text: 'Learn more about TÜV SÜD certification and how it guarantees the quality of our tires. Here you can consult detailed reports and test results carried out by TÜV SÜD, which validate the safety, durability, and performance of our tires.',
            see_btn: 'Discover the results'
          }
        },

        tire_knowledge:{
          title: 'Tire Information',
          subtitle: 'We are proud of the quality and durability of our tires. Here we share information about how to buy the right tires, how to care for them properly, tips for replacing and mounting, and much more. Stay informed for a smoother and safer journey. Because in tires, knowledge is key to optimal performance and safety.',

          saber_mas: 'Learn more',
          posts:[
            {
              hashtag: '#Tire Knowledge',
              title: 'Basic Definitions',
              subtitle: 'The basics of tires and the advantages of tubeless technology'
            },
            {
              hashtag: '#Tire Knowledge',
              title: 'How to Read Tires',
              subtitle: 'Understanding how tire sizing works is crucial'
            },
            {
              hashtag: '#Tire Knowledge',
              title: 'Tire Structure',
              subtitle: 'Unveiling the anatomy of the tire and its key components for performance and safety'
            },
            {
              hashtag: '#Daily Use',
              title: 'Why Use EV Tires?',
              subtitle: 'Choosing the right tires for electric vehicles (EVs) is crucial for improving performance'
            },
            {
              hashtag: '#Daily Use',
              title: 'What’s the Difference Between Tires?',
              subtitle: 'Differences between sedan, truck, and SUV tires for optimal performance and safety'
            },
            {
              hashtag: '#Daily Use',
              title: 'What Should Tire Pressure Be in Summer?',
              subtitle: 'Ensuring proper tire pressure during the summer months is essential.'
            }
          ]
        },

        about_us:{
          title: 'EMPOWERING ELECTRIC MOBILITY IN COSTA RICA',
          subtitle: [
            'At Mundo EV, we don’t just sell tires; we drive the future of mobility in Costa Rica. We firmly believe that every kilometer driven in an electric vehicle is not only efficient but also a declaration of commitment to our planet.',
            'That’s why we are dedicated to offering specialized and cutting-edge solutions that enhance your electric car experience.'
          ],
          buttons:[
            'Commitments', 'Values', 'What We Offer', 'Company'
          ],
          empresa:{
            title: 'Our Story: Vision and Combined Experience',
            description: [
              'Mundo EV was born from a clear vision and a unique opportunity in a rapidly growing market. We’ve combined international experience with deep knowledge of the Costa Rican landscape to create a company that not only meets a need but anticipates it.',
              'Our founding partners, with decades of experience in complementary fields, saw the perfect synergy: leveraging global contacts, vast knowledge of the European tire market, and pioneering experience in electric vehicles in Costa Rica. This fusion positions us strategically to lead the supply of high-quality products for a sector that is growing exponentially in our country.'
            ]
          },
          compromisos:{
            title: 'Our Mission and Vision',
            description: [
              'Make the operation of your electric vehicle in Costa Rica easy, safe, and efficient, ensuring worry-free mobility for every owner.',
              'By 2030, we will be the leading and most diversified company in electric vehicle solutions in Costa Rica, recognized for our excellence, innovation, and contribution to the country’s sustainable development.'
            ]
          },
          valores:{
            title: 'The Core of Our Commitment',
            description: 'Every decision and interaction at Mundo EV is guided by our core values:',
            list:[
              {
                title: 'Integrity',
                information: 'We act with transparency and honesty in everything we do.'
              },
              {
                title: 'Responsibility',
                information: 'We uphold our commitment to our customers, the environment, and society.'
              },
              {
                title: 'Quality',
                information: 'We only offer products that meet the highest standards and expectations.'
              },
              {
                title: 'Innovation',
                information: 'We are constantly seeking the best and most advanced solutions for electric mobility.'
              },
              {
                title: 'Respect',
                information: 'We value our customers, collaborators, and the ecosystem in which we operate.'
              }
            ]
          },
          que_ofrecemos:{
            title: 'Products Designed for Your EV',
            description: [
              'At Mundo EV, we specialize in products designed exclusively for electric vehicles, ensuring optimal performance and unmatched operation.',
              'Initially, we focus on high-end tires, such as our Prinx brand, specifically designed for the demands of electric vehicles: greater weight, high torque, and the need for efficiency and quietness. These tires not only promise durability and safety but also directly contribute to greater range and driving comfort.',
              'As we grow, we will expand our offerings to include a range of high-quality services and parts, all aimed at making your electric vehicle operation in Costa Rica easier and more reliable.'
            ]
          },
          ubicacion: {
            title: 'Costa Rica Headquarters'
          }

        },
        partners:{
          title:'Become a national distributor of our products.',
          subtitle:[
            'We are looking for motivated partners who value excellence and quality to distribute PRINX products in Costa Rica',
            'Complete the following form to start the partnership process',
            "Don't miss this opportunity, join our distribution network."
          ],
          next_steps_text:'Complete the following form',
          company:{
            title:'Company - Business',
            placeholder:'Company name'
          },
          name:{
            title:'Full name',
            placeholder:'Enter your name'
          },
          address:{
            title:'Address',
            placeholder:'Enter your address'
          },
          phonenumber:{
            title:'Phone',
            placeholder:'Enter your phone number'
          },
          email:{
            title: "Email",
            placeholder: "Enter your email address"
          },
          website:{
            title:'Website',
            placeholder:'Enter your website'
          },
          comments:{
            title:'Comments',
            placeholder:'Enter your comments'
          },
          send_btn:{
            title:'Send'
          },
          success_message:'Your information was sent successfully.',
          error_message:'Your information could not be sent, please try again later',
        },
        xnex_page: {
          general_titles: {
            categories: [
              "Vehicle",
              "Electric Vehicle",
              "Summer"
            ],
            characteristics_title: "Optional Features",
            buy_btn: "Buy"
          },
          hero: {
            title: "XNEX SPORT EV",
            subtitle: "EV ULTRA HIGH PERFORMANCE ",
            description: "UNLEASH YOURSELF AND ENJOY A SPORTY DRIVE. THE EXCITING CHOICE FOR ELECTRIC VEHICLES."
          },
          second_section: {
            title: "Designed for Electric Vehicles",
            description: "PRINX is revolutionizing electric mobility with tires specially designed for electric vehicles. Engineered for greater range and superior traction, these eco-friendly tires offer a smooth and quiet ride. With sustainability in mind, PRINX tires combine innovation and environmental awareness to deliver a greener journey."
          },
          third_section: {
            title: "XNEX SPORT EV Tire Technologies",
            description: "Experience the future of tire innovation with XNEX SPORT EV, featuring cutting-edge technologies designed to redefine your driving experience.",
            details: [
              "Experience the velvety touch of Inktech™ laser carving molds. This revolutionary technology uses fine textures to reflect and absorb light multiple times, resulting in a darker and more profound tire appearance.",
              "The internal foam reduces low-frequency cavity noise by up to 12.6 dB and overall interior noise by 1–2 dB without compromising other features like handling and fuel efficiency.",
              "A self-sealing rubber layer is applied beneath the tread. When punctured, the sealing compound flows to the damaged area to prevent air leakage, avoiding blowouts or loss of control, and enhancing safety."
            ]
          },
          fourth_section: {
            title: "Shoulder Pattern",
            description: "The massive and connected shoulder blocks provide better support for sporty driving."
          }
        },
        xlab_page: {
          general_titles: {
            categories: [
              "Vehicle",
              "Electric Vehicle",
              "Summer"
            ],
            characteristics_title: "Optional Features",
            buy_btn: "Buy"
          },
          hero: {
            title: "XLAB COMFORT EV",
            subtitle: "HIGH PERFORMANCE EV Tire",
            description: "FOR A QUIET AND COMFORTABLE RIDE, EVEN IN WET CONDITIONS."
          },
          second_section: {
            title: "Quiet and Comfortable Ride",
            description: "XLAB Comfort EV is designed to deliver superior wet grip, extended tread life, and a velvety finish."
          },
          third_section: {
            title: "XLAB COMFORT EV Tire Technologies",
            description: "Experience the future of tire innovation with XLAB COMFORT EV, featuring cutting-edge technologies designed to redefine your driving experience.",
            technologies: [
              "Silence and comfort thanks to a unique design.",
              "Safe driving on wet roads. Improved wet grip thanks to a new and innovative tread compound.",
              "Extended tread life due to an optimized profile for even wear.",
              "Beauty and uniqueness of the velvet sidewall.",
              "Top-tier labeling grade."
            ],
            details: [
              "Experience the velvety touch of Inktech™ laser carving molds. This revolutionary technology uses fine textures to reflect and absorb light multiple times, resulting in a darker and more profound tire appearance.",
              "The internal foam reduces low-frequency cavity noise by up to 12.6 dB and overall interior noise by 1–2 dB without compromising other features like handling and fuel efficiency.",
              "A self-sealing rubber layer is applied beneath the tread. When punctured, the sealing compound flows to the damaged area to prevent air leakage, avoiding blowouts or loss of control, and enhancing safety."
            ]
          },
          fourth_section: {
            title: "Closed Shoulder Design",
            description: "The closed shoulder prevents pumping noise from the tread from escaping and is more environmentally friendly."
          },
          fifth_section: [
            {
              title: "PRINX Control and Comfort Balance Tire Balance Theory",
              description: "Optimized section profile for heavier loads to prevent uneven wear."
            },
            {
              title: "Tread Compound for Balanced Performance",
              description: "Ensures wet grip while maintaining long tread life."
            }
          ]
        },
        tire_search: {
          general_title: 'Choose a category to perform a search',
          category: 'Category',
          products: 'Products',
          car_model: 'Vehicle model',
          tire_size: 'Tire size',
          title: "Enter the tire size",
          search_btn: "Search tire",
          ancho: "Width",
          perfil: "Profile",
          tamano_aro: "Rim size"
        },
        posts: {
          volver_text: "Back",
          basic_definitions: {
            title: "Basic Definitions",
            subtitle: "The fundamentals of tires and the advantages of tubeless technology",
            section_one: {
              body: [
                "Definition and function of a tire",
                "The ETRTO (European Tyre and Rim Technical Organisation) defines a tire as: \"A tire is a flexible component of the wheel assembly, made of rubber and reinforcement materials. Inflating the tire with compressed gas enables it to support the wheel’s load as part of the axle load and to transmit longitudinal and lateral forces. When unloaded, the inflated tire is essentially toroidal.\"",
                {
                  title: "Load",
                  body: "Contains a volume of pressurized air to support the vehicle’s load"
                },
                {
                  title: "Provide grip",
                  body: "Transmits traction and braking forces to the road surface"
                },
                {
                  title: "Shock absorption",
                  body: "Supports the vehicle’s suspension by absorbing surface impacts"
                },
                {
                  title: "Steering assistance",
                  body: "Provides directional stability when changing or maintaining direction"
                }
              ]
            },
            section_two: {
              body: [
                "Advantages of tubeless tires",
                "Tubeless technology eliminates the use of inner tubes. Once mounted, the tubeless tire forms an airtight seal with the rim.",
                {
                  title: "Slow air leaks",
                  body: "Air escapes more slowly compared to tube-type tires"
                },
                {
                  title: "Increased safety",
                  body: "The driver retains control and has more time to maneuver or reach a nearby tire shop compared to tube-type tires"
                },
                {
                  title: "Fuel savings",
                  body: "Tubeless tires are lighter due to the absence of an inner tube, resulting in greater mileage with the same amount of fuel"
                },
                {
                  title: "Reduced friction",
                  body: "Friction between the tire and inner tube is eliminated in tubeless tires, reducing rolling resistance and enhancing driving comfort"
                },
                {
                  title: "Use of sealant",
                  body: "Modern tubeless tires may include a liquid sealant for automatic puncture repair, preventing air loss"
                },
                {
                  title: "Driving comfort",
                  body: "Tubeless tires allow a more precise fit on the rim, greater overall uniformity, and improved balance, resulting in superior ride comfort compared to tube-type tires"
                }
              ]
            }
          },
          how_to_read_tires: {
            title: "How to Read Tires",
            subtitle: "Understanding tire sizing is essential",
            body: [
              "Understanding how tire sizing works is crucial before purchasing a new one. As shown in the diagram below, all necessary information is found on the tire itself.",
              "Tire sidewall",
              "Load Index: the maximum load capacity of the tire, based on the load index chart. In this case, 94 corresponds to 670 kg as the maximum load.",
              "Speed Rating: the maximum allowable speed for the tire. As shown in the chart below, V indicates 240 km/h (150 mph)",
              "Tire size designation: a tire marked 215/55R17 indicates a section width of 215 mm, 55 is the aspect ratio (the ratio between sidewall height and section width), and R is the structural code for radial tires. 17 is the rim diameter in inches.",
              [
                "215: nominal section width of the tire",
                "55: nominal aspect ratio",
                "R: radial construction code",
                "17: nominal rim diameter (inches)",
                "94: load index (load capacity 670 kg)",
                "V: tire speed rating (V = maximum operating speed 240 km/h or 150 mph)"
              ],
              "Tire speed rating",
              "The speed rating indicates the maximum speed a tire can safely maintain over time. The higher the rating, the better control and handling at higher speeds."
            ]
          },
          tire_structure: {
            title: "TIRE STRUCTURE",
            subtitle: "Anatomy of tubular tires and their key performance and safety components",
            body: [
              "Understanding a tire’s structure is essential to appreciate its impact on overall vehicle performance. From layers of advanced materials to intricate tread designs, every component in a tire’s complex anatomy contributes to safe and efficient handling.",
              "COMPONENTS OF A RADIAL TIRE",
              "1: TREAD / LUG",
              "Made from a thick rubber layer that contacts the road directly. It’s designed to resist cracks and impacts, protecting the casing and inner layers. Each brand uses proprietary rubber blends to enhance grip and durability—especially suited for EV needs. The tread also helps evacuate water and improve traction and braking.",
              "2 & 3: SHOULDER AND SIDEWALL / PROFILE",
              "Located between the shoulder and the bead, the sidewall protects the casing and enhances handling quality through flexible motion. It also displays important information, such as tire type, standards, dimensions, manufacture date, manufacturer name, and model.",
              "4 & 9: BEAD AND FLANGE",
              "The bead encircles the edge of the cord, anchoring the tire to the rim. It includes several components like the bead wire, core, rubber, and filler. Typically, the rim compresses the bead slightly to prevent dislodging in case of sudden air pressure loss during driving.",
              "5: CASING",
              "The most crucial part of the tire, maintaining internal pressure and shape while absorbing loads and shocks. Especially important in EV tires.",
              "6: BELT / BREAKER",
              "Reinforced cords made of nylon, Kevlar, etc., embedded in rubber and wrapped around the tire circumference. Especially designed for EV tires.",
              "7: INNER LINER",
              "The inner liner replaces the tube inside the tire, made of rubber with excellent airtight properties. These are called tubeless tires. Typically made of butyl rubber, synthetic rubber, or polyisoprene. See PRINX’s Silentek and Healtek technologies.",
              "8: STEEL AND NYLON PLIES",
              "Multiple steel belt layers placed at an angle to support the tread and ensure even wear, high traction, and control. Made of high-strength steel and applied above the casing. Passenger tires generally feature two or more layers. Materials and blends vary by manufacturer and tire model, depending on vehicle type (e.g., EVs)."
            ]
          },
          use_ev_tires: {
            title: "Why Is It Better to Use Tires Specifically for Electric Vehicles?",
            subtitle: "Selecting the right tires for EVs is key to enhancing their performance",
            body: [
              "Generally, people choose BEVs (Battery Electric Vehicles) over ICEVs (Internal Combustion Engine Vehicles) for lower operating costs and a superior driving experience. Additionally, driving a BEV contributes to climate change mitigation.",
              "The main difference between BEVs and ICEVs lies in their drive systems. ICEVs depend on engines and transmissions, while BEVs are powered by batteries, resulting in heavier vehicles. This weight directly impacts tire wear and braking distance, requiring enhanced tire performance.",
              "As BEV users expect longer driving ranges, tires must also reduce rolling resistance. Because BEV motors deliver high torque, they require tires with superior grip.",
              "Moreover, while BEVs lack engine and transmission noise, tire noise remains perceptible. Therefore, EV tires must absorb road vibrations and noise, ensuring a quieter and more comfortable ride."
            ]
          },
          whats_difference: {
            title: "What Is the Difference Between Tires?",
            subtitle: "Differences between passenger car, truck, and SUV tires for optimal performance and safety",
            body: [
              "A 'one-size-fits-all' approach may seem convenient but rarely works when choosing vehicle tires.",
              "Different types of car tires are suited to different applications and driving environments. Understanding tire types, their proper use, and the technical reasons behind their suitability will help you make the best choice.",
              "Tires are the most adaptable component of a car, and there are subtle differences among SUV, truck, and passenger car tires. Choosing the right set can be complicated for owners.",
              "Although many vehicle owners use them interchangeably, SUV and passenger tires are built for different functions. SUVs require tires for heavier loads and tougher conditions, while passenger tires are optimized for transporting people and light cargo.",
              {
                title: "Passenger Car Tires",
                body: [
                  "Passenger tires are designed for sedans, minivans, and compact SUVs. They provide a quiet and comfortable ride, excellent traction, and long-lasting tread. Due to their lighter construction, they are not suitable for heavy-duty vehicles or large cargo loads.",
                  "Most passenger car tire models are all-season rated and often display the M+S symbol indicating multi-season capability. Many people wonder if passenger tires can be used on SUVs—the answer is yes, in certain cases."
                ]
              },
              {
                title: "Light Truck Tires",
                body: [
                  "Light truck or LT-metric tires have stiffer sidewalls and deeper tread than passenger tires (P-metric). Their reinforced construction makes them better suited to challenging terrain and hauling heavy loads.",
                  "LT-metric tires offer better control when transporting heavy equipment or cargo, making them a preferred choice for trucks and large SUVs."
                ]
              },
              {
                title: "SUV Tires",
                body: [
                  "SUV tires are designed to be more versatile and capable than regular passenger car tires. They are built to handle heavy loads and towing, while remaining flexible when needed. They also feature more durable designs for rough terrain.",
                  "When buying SUV tires, drivers should consider the vehicle's load capacity. Always match the maximum desired load with the appropriate load index. These tires are designed for snow, mud, or gravel and use thick rubber compounds with aggressive tread patterns.",
                  "They provide better traction and impact resistance. However, if driven mostly on paved roads, aggressive treads may compromise comfort and handling."
                ]
              },
              {
                title: "Truck Tires vs. SUV Tires",
                body: [
                  "What is the difference between truck tires and SUV tires? Truck tires are usually more aggressive, with taller sidewalls, and are certified for heavier loads. Despite size similarities, many truck tires are available in SUV sizes and vice versa, which can blur the distinction.",
                  "Some modern trucks can use SUV-size tires, and some SUVs use truck-size tires. The key differences are in construction and performance design."
                ]
              },
              {
                title: "Passenger Tires vs. Light Truck Tires",
                body: [
                  "It’s also important to understand the difference between passenger tires and light truck (LT) tires. Trucks can use LT tires, but SUVs typically cannot. LT tires can carry heavier loads compared to passenger tires.",
                  "LT tires often use thicker rubber compounds, making them more durable—but usually more expensive. However, they tend to offer a stiffer ride. Passenger tires are more affordable and provide smoother driving but are not built for carrying heavy loads."
                ]
              }
            ]
          },
          tire_presure: {
            title: "What Should Tire Pressure Be in Summer?",
            subtitle: "Ensuring proper tire pressure during summer is essential",
            body: [
              "Tire pressure is a key factor in ensuring smooth and safe driving. Air inside the tire reacts to temperature changes, so it's important to monitor whether the pressure is suitable for the car and the road.",
              "Although tire pressure may stay consistent year-round, it may fluctuate in places with frequent temperature changes or during travel.",
              {
                title: "What should tire pressure be?",
                body: [
                  "Each vehicle has a different ideal tire pressure. For the most accurate recommendation, consult the vehicle manufacturer. As a general rule, a 10°F increase in temperature can result in a 1 psi increase in pressure.",
                  "The standard reference temperature for tire pressure is 20°C (68°F). Both overinflation and underinflation can cause problems—minor issues at best and serious accidents at worst. For most cars, recommended pressure ranges between 30 and 35 psi.",
                  "During summer, air inside the tire expands as temperature rises, potentially leading to overinflation. In extreme cases, this may even cause a blowout. Always reduce tire pressure only when the tire is cool, since manufacturers provide specifications based on cold tires.",
                  "According to the European Tyre and Rim Technical Organisation (ETRTO 2001), hot tire pressure can be up to 20% higher than cold pressure. Under no circumstances should hot tires be inflated to the manufacturer’s cold pressure rating."
                ]
              },
              {
                title: "How to check tire pressure?",
                body: [
                  "You should regularly check tire pressure to monitor air levels. Correct pressure ensures safety and smooth driving. This can be done at a gas station or at home.",
                  "Here are the steps to check tire pressure at home:",
                  [
                    "Ensure the tire is cold. This means the car hasn’t been driven for at least three hours.",
                    "Find the manufacturer’s recommended pressure, usually located on a label inside the car door.",
                    "Use a pressure gauge. Remove the valve cap and press the gauge onto the valve stem.",
                    "Press the valve pin to release excess air. You’ll hear a hissing sound. Continue until the sound subsides.",
                    "Wait for the gauge reading to stabilize and compare it with the manufacturer’s recommended level.",
                    "If the reading is too high, release some air; if too low, add air. Do this gradually while checking frequently."
                  ],
                  "Be sure to check all four tires. Even one under- or overinflated tire can significantly affect performance and safety. If checking at a gas station, the tires may be hot—adjust the psi accordingly."
                ]
              }
            ]
          }
        },
        privacy_policy:{
          titulo: "Privacy policy",
          introduccion: "On our website, we respect your privacy and protect your personal data. This policy explains how we collect, use, and safeguard your information.",
          recopilacion_datos: "We collect information such as name, email, phone number, and shipping address solely to process your orders.",
          uso_datos: "The collected information is used exclusively to provide our services, contact customers, and improve their shopping experience.",
          proteccion_datos: "We implement security measures to protect your data against unauthorized access, loss, or alteration.",
          terceros: "We do not share your personal information with third parties except when necessary to complete the purchase process (e.g., delivery services).",
          derechos_usuario: "You have the right to access, correct, or delete your personal information at any time.",
          contacto: "For questions about this policy, contact us through our customer service email."
        },
        cookies_policy:{
          title: 'Cookies policy',
          introduction: "On our website, we use cookies to enhance the user experience and provide personalized content. Cookies are small text files stored on your device that help us remember information about you and your preferences.",
          types_of_cookies: "Types of Cookies We Use:",
          technical_cookies: "These cookies are essential for the basic operation of our website, such as keeping your session active or allowing you to navigate between different pages.",
          analytics_cookies: "We use analytics tools, such as Google Analytics, to collect information about how you use our site. This helps us understand which areas are popular and how we can improve navigation and the overall user experience.",
          advertising_cookies: "We may use cookies to show you ads that are relevant to your interests. These cookies may be set by us or by third parties, such as social networks or advertising companies.",
          cookie_management: "You can manage cookies through your browser settings. You can choose to block all cookies, accept only certain ones, or delete them entirely. Please note that disabling cookies may cause some features of our website to function improperly.",
          consent: "By visiting our website, you accept the use of technical cookies. If we wish to use analytics or advertising cookies, we will ask for your consent before placing them on your device.",
          contact: "If you have any questions about our cookie policy, feel free to contact us via [email address or contact form].",
          updates: "We reserve the right to update this cookie policy at any time. We will notify you of any significant changes through our website."

        },
        comingSoonEcommerce: {
          title: 'Thank you for choosing us!',
          body: 'Very soon in our online store with the best prices on tires for your electric vehicle.',
          button_text: 'Visit us on Facebook'
        },
        termsOnlineSale: {
          title: 'Terms and Conditions of Online Tire Sale',
          subtitle: 'Last update: July 23, 2025',
          sections: [
            {
              title: '1. Acceptance of the Terms',
              body: [
                'By accessing and using this website, www.prinxcr.com, You acknowledge having read, understood, and accepted these Terms and Conditions in full.',
                'If you do not agree with any of the clauses, please do not use our services.'
              ]
            },
            {
              title: '2. Definitions',
              body: [
                'Customer: Natural or legal person who makes purchases on the site.',
                'Seller: Mundo EV S.A., responsible for the marketing of tires.',
                'Product: Any tire or accessory available for sale.',
                'Order: Purchase request formalized through the platform.'
              ]
            },
            {
              title: '3. Registration and User Account',
              body: [
                'To make purchases, the customer must create an account providing truthful information.',
                'The customer is responsible for maintaining the confidentiality of their username and password, as well as for all activities carried out under their account.',
                'We reserve the right to suspend or cancel accounts in case of detecting misuse or fraud. The e-commerce site www.prinxcr.com only allows purchases by users accessing from Costa Rica.'
              ]
            },
            {
              title: '4. Purchase Process',
              body: [
                'Select the product(s) and add them to the cart.',
                'Complete billing and shipping information.',
                'Choose the payment method and confirm the operation.',
                'You will receive a confirmation email with the summary of your order.',
                'The order is subject to availability until payment is confirmed.'
              ]
            },
            {
              title: '5. Prices, Promotions, and Payment Methods',
              body: [
                'Prices are expressed in colones and include applicable taxes.',
                'Promotions have validity dates and specific conditions; their application will be subject to the terms of each offer.',
                'Accepted payment methods:',
                'Credit / debit cards',
                'In case of a typographical error in the price, we reserve the right to cancel the order and refund the customer.'
              ]
            },
            {
              title: '6. Shipping and Deliveries',
              body: [
                'We offer coverage in most of the territory of Costa Rica. Estimated times are:',
                'Zone Estimated delivery time',
                'GAM',
                '1-3 business days',
                'Rural Zone',
                '3-5 business days',
                'The indicated delivery times will be met in most cases but are a reference; the delivery date will be provided at the moment the order is confirmed via email.',
                'The customer must check the condition of the package at the time of delivery and report damage or missing items within 24 hours. The customer duly authorizes other persons at the delivery address to receive the order.',
                'The shipping cost will be indicated at the time of generating the order and must be paid along with the product purchase.'
              ]
            },
            {
              title: '7. Returns, Exchanges, and Warranties',
              body: [
                'Returns or exchanges of our products are not accepted; however, MUNDO EV reserves the right, at its sole discretion, to accept returns or exchanges in special cases.',
                'In such cases, the return costs will be borne by the person requesting the exchange, except in case of factory defect.',
                'Tires have a 30 (thirty) day manufacturer’s warranty from the date of purchase; this warranty is limited to factory defects and/or damages, and does not apply to normal wear, impacts, scratches, physical damage, alterations, incorrect installation, or improper use.',
                'To process a claim, the customer must send a copy of the invoice and photos of the product to the email info@evmundo.com and indicate the reason for the claim or dissatisfaction with the product quality.'
              ]
            },
            {
              title: '8. Intellectual Property',
              body: [
                'All site content (texts, images, logos, trademarks) is protected by intellectual property laws.',
                'Total or partial reproduction without express authorization from Mundo EV S.A. is prohibited.'
              ]
            },
            {
              title: '9. Privacy and Data Protection',
              body: [
                'We process your personal data in accordance with our Privacy Policy, which you can consult on this page.'
              ]
            },
            {
              title: '10. Use of Cookies',
              body: [
                'We use cookies to improve the browsing experience and offer personalized content.',
                'The customer can disable cookies from their browser settings, although some site functions may not work properly.'
              ]
            },
            {
              title: '11. Limitation of Liability',
              body: [
                'Mundo EV S.A. will not be responsible for:',
                'Indirect damages, loss of profits or losses derived from the use of the site.',
                'Delays caused by force majeure or transportation providers.',
                'Our maximum liability is limited to the value of the corresponding order.'
              ]
            },
            {
              title: '12. Modifications of the Terms',
              body: [
                'We may update these Terms at any time.',
                'Changes will be published on this page with the last update date.',
                'Continued use of the site after the publication of modifications implies acceptance of the new conditions.'
              ]
            },
            {
              title: '13. Applicable Law and Jurisdiction',
              body: [
                'These Terms are governed by the laws of the Republic of Costa Rica.',
                'For the resolution of disputes, both parties submit to the jurisdiction of the courts of the City of San José.'
              ]
            },
            {
              title: '14. Contact and Customer Service',
              body: [
                'If you have questions or need assistance, you can contact us:',
                'Email: info@prinxcr.com',
                'Customer service hours: Monday to Friday, 9:00 - 18:00',
                'Thank you for choosing us. Let’s roll together!'
              ]
            }
          ]
        }


      },
      
    };

    return language === 'es' ? texts['es'] : texts['en'];
  }

}
